// extracted by mini-css-extract-plugin
export default {"viewer_container":"Viewers_viewer_container__FKIN3","option":"Viewers_option__CndWC","videoTag":"Viewers_videoTag__s50nN"};